import { Component, Prop, Watch, Vue } from 'vue-property-decorator';

import { formatCurrency } from '@/core/currency/helpers';
import { CurrencyInfo } from '@/core/currency/interfaces';
import Countdown from '@/core/countdown';
import ActionBtn from '@/views/checkout/components/action-btn';
import {
    getLoyaltyProgramIcon
} from '@/views/checkout/components/payment-methods/payment-card/components/loyalty-programs/dynamic-components';
import { Order } from '@/views/checkout/interfaces';
import LoyaltyReceipt from '../loyalty-receipt';
import { TransactionInfo } from '../../../../interfaces';

@Component({
    data() {
        return {
            opened: false
        };
    },
    components: {
        ActionBtn,
        LoyaltyReceipt,
        Countdown
    }
})
export default class LoyaltySuccessModal extends Vue {
    @Prop(Boolean)
    value: boolean;

    @Prop(Object)
    currency: CurrencyInfo;

    @Prop(Object)
    order: Order

    @Prop(Object)
    transactionInfo: TransactionInfo;

    @Prop()
    supportsReceipt: boolean;

    opened: boolean;

    mounted() {
        this.opened = this.value;
    }

    @Watch('value')
    onChangeValue(value: boolean) {
        this.opened = value;
    }

    @Watch('opened')
    onChangeOpened(value) {
        this.$emit('input', value);
    }

    get earnedPoints() {
        return formatCurrency(
            this.transactionInfo.loyalty.pointsEarned || '0',
            this.currency?.format,
            '0,0'
        );
    }

    get balancePoints() {
        return formatCurrency(
            this.transactionInfo.loyalty.pointsBalance || '0',
            this.currency?.format,
            '0,0'
        );
    }

    get redeemedPoints() {
        return formatCurrency(
            this.transactionInfo.loyalty.pointsRedeemed || '0',
            this.currency?.format,
            '0,0'
        );
    }

    get redeemedAmount() {
        return formatCurrency(
            this.transactionInfo.loyalty.amountRedeemed / 100 || '0',
            this.currency?.format,
            '0,0.00'
        );
    }

    get icon() {
        return getLoyaltyProgramIcon(this.transactionInfo.loyalty.programId);
    }

    close() {
        this.opened = false;

        window.location.href = this.transactionInfo.redirectUrl;
    }

    format(value: number, format: string) {
        return formatCurrency(
            value || '0',
            this.currency?.format,
            format
        );
    }
}
